import EditTalentContainer from "../containers/EditTalentContainer";

const EditTalentPage = () => {
  return (
    <EditTalentContainer />
  );
};

export default EditTalentPage;
